import React, {Component} from 'react'
import FormatMessage from "../messages/FormatMessage";
import EQLeftNavigation from './tags/EQLeftNavigationTree'
import {handleFormSubmit, submitFormData} from "../assets-static/scripts/Validation";
import {loadApplicationData, pageDetails, saveApplicationData} from "../actions/ApplicationAction";
import {isFirstPage} from "../assets-static/scripts/utils";
import {injectIntl} from "react-intl";
import dot from "dot-object";

                                    import RadioOptionWithValue from "./tags/RadioOptionWithValue";
                                        import {EQ_Button_Navigation} from "./tags/EQ_Button_Navigation";
import { withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import EQHeader from './EQHeader';
import EQFooter from './EQFooter';
import EQMobileMenu from "./EQMobileMenu";

class EQ_1_6 extends Component {
constructor(props) {
super(props);
this.state = {
isValid: true,
mobileMenu: false
}
this.handleMobileMenu = this.handleMobileMenu.bind(this);
}

componentDidMount() {
handleFormSubmit(this.props)
}

handleNext = (element) => {
const isValid = submitFormData()
if (isValid) {
element.className = element.className + " LoadingButton LoadingButton-loading";
pageDetails("imm5444epremium", this.props.application.applicationData, "NEXT", "EQ-1.6", "PAGE_STATUS_COMPLETE").then((nextPage) => {
element.className = element.className.replace(" LoadingButton LoadingButton-loading", "")
if (nextPage != "") {
loadApplicationData("imm5444epremium").then((data) => {
this.props.dispatch(data)
nextPage.includes("http") ? window.location.href = nextPage :
nextPage.includes("redirect") ? window.location.href = nextPage.split("redirect=")[1] :
this.props.history.push(nextPage);
});
}
});
} else {
this.setState({
isValid: isValid
})
}
}

handlePrevious = () => {
pageDetails("imm5444epremium", this.props.application.applicationData, "PREV", "EQ-1.6", "PAGE_STATUS_NOT_VISITED").then((prevPage) => {
this.props.history.push(prevPage);
});
}

hasBack = () => {
                                                                                              return !isFirstPage("EQ-1.6", ["EQ-1.1","EQ-1.3","EQ-1.5","EQ-1.6","EQ-1.7.1","EQ-1.7.2","EQ-1.7.3"]);
}

handleMobileMenu(value) {
this.setState({
mobileMenu: value
})
}

render() {
return (
<div className="Site">
    <EQHeader handleMobileMenu={(value) => this.handleMobileMenu(value)}/>
    <div className="SiteContent">
        <div className="SiteContent-container">
            <div className="App">
                <div className="EqSubHeader">
                    <div className="EqSubHeader-form">
                        <FormatMessage id="form.title"/>	
                    </div>
                    <div className="EqSubHeader-label">
                        <FormatMessage id="eq-pageheader"/>
                    </div>
                </div>
                <div className="FixedLayout App-layout">
                    <div className="FixedLayoutAside App-aside">
                        <EQLeftNavigation hasSidebar="true" closedSectionKey="eq.lnt.section.closed"/>
                    </div>
                    <div className="FixedLayoutMain App-main">
                        <div className="Page">
                            <form id="application_form">
                                <div className="EqQuestionPage">
                                    {!this.state.isValid &&
                                    <div className="PageError">
                                        <div className="PageError-label">
                                            <FormatMessage id="control.complete.highlightedfields"/>
                                        </div>
                                    </div>
                                    }
                                    <div className="Questions EqQuestionPage-questions">
                                                                                                                                    <div className="QuestionSectionGroup">
                                                                                                                                                                <RadioOptionWithValue beanName="applicationData" property="quiz.reasonOfApplication" personalisation="true" 
questionKey="EQ-1.6.pagetext.1" 
required="true" 
option_label_1="EQ-1.6.pagetext.radio1" 
option_label_2="EQ-1.6.pagetext.radio2" 
option_label_3="EQ-1.6.pagetext.radio3" 
option_label_4="EQ-1.6.pagetext.radio4" 
option_label_5="EQ-1.6.pagetext.radio5" 
option_label_6="EQ-1.6.pagetext.radio6" 
option_label_7="EQ-1.6.pagetext.radio7" 
option_label_8="EQ-1.6.pagetext.radio8" 
option_value_1="prCardLost" 
option_value_2="prCardStolen" 
option_value_3="prCardDestroyed" 
option_value_4="prCardNeverReceived" 
option_value_5="prCardFirst" 
option_value_6="prCardExpiringOrNewName" 
option_value_7="recordOfLandingOrConfirmationOfPrIncorrect" 
option_value_8="otherReason" 
errorKey="error.control.pleaseselect" 
 application={this.props.application} dispatchApplicationData={this.dispatchApplicationData.bind(this)} />
                                                                                                                                                        </div>
                                                                                                                        </div>
                                    <EQ_Button_Navigation hasBack={this.hasBack()}
                                                          navNext={this.handleNext}
                                                          navPrevious={this.handlePrevious}>
                                    </EQ_Button_Navigation>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <EQFooter />
    {this.state.mobileMenu &&
    <EQMobileMenu handleMobileMenu={(value) => this.handleMobileMenu(value)}/>
    }
</div>)
}
dispatchApplicationData(applicationData) {
this.setState({
isValid: true
})
this.props.dispatch(saveApplicationData(applicationData))
}
}

const mapStateToProps = state => {
return {
application: state.application
}
}

export default connect(mapStateToProps)(injectIntl(withRouter(EQ_1_6)))
